import { NativeDateAdapter } from '@angular/material/core';
import * as moment from 'moment';

export class CustomDateAdapter extends NativeDateAdapter {
  constructor(matDateLocale: string) {
    super(matDateLocale);
  }

  getDayOfWeekNames(style: 'long' | 'short' | 'narrow') {
    return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  }

  format(date: Date, displayFormat: string): string {
    const momentDate = moment(date);
    return momentDate.format(displayFormat);
  }
}